import styled from '@emotion/styled';
import { captionSb } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';
import Link from 'next/link';

import type { WebinarCourseType } from '@/api/webinar';

export const Banner = styled(Link)<{ course: WebinarCourseType }>`
  width: 100%;
  aspect-ratio: 364/84;
  position: relative;
  padding: 20px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid
    ${({ course }) => {
      switch (course) {
        case 'full':
          return '#222425';
        case 'plus-backend':
          return 'rgba(222, 25, 18, 0.40)';
        case 'plus':
          return 'rgba(222, 25, 18, 0.40)';
      }
    }};
  background-color: ${({ course }) =>
    course === 'plus' ? 'rgba(222, 25, 18, 0.08)' : 'transparent'};
`;

export const ImageWrapper = styled.div`
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
`;
export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const TextWrapper = styled.div`
  ${captionSb};
  color: ${vars.neutral[0]};
`;
export const Container = styled.div<{ backgroundImageUrl: string }>`
  width: 100%;
  display: flex;
  padding: 24px 20px;
  align-items: center;
  gap: 20px;
  border-radius: 16px;
  border: 1px solid rgba(222, 25, 18, 0.4);
  background: ${({ backgroundImageUrl }) => `
    url(${backgroundImageUrl}),
    #25282a
  `};
  background-size: cover;
  background-position-y: -43px;
  position: relative;
`;
